import locale from 'locale-codes';

const allLanguages = locale.all
  .filter((localeOption) => localeOption.location)
  .map((localeOption) => ({
    label: `${localeOption.name} (${localeOption.location})`,
    value: localeOption.tag.replace('-', '_'),
  }));

export default allLanguages;
